export const homeCarouselData = [
  {
    imageSm: "https://i.postimg.cc/t7QB6DTx/MOB-AVK-2-x600.webp",
    path: "/wedding_collection/shervani/plain_shervani",
    imageLg: "https://i.postimg.cc/wTr6Cmrs/avk-banner-3-1600x.webp",
  },
  {
    imageSm: "https://i.postimg.cc/SKJ1wnwj/AVK-MOB-1-x600.webp",
    path: "/wedding_collection/shervani/plain_shervani",
    imageLg: "https://i.postimg.cc/sf9mHPvw/avk-ban-3-1600x.webp",
  },
  {
    imageLg: "https://i.postimg.cc/85wFMCzB/avk-banner-4-1600x.webp",
    imageSm: "https://i.postimg.cc/Qt6tVnff/mens-kurtas-x600.webp",
    path: "/wedding_collection/shervani/plain_shervani",
  },
];
